function DashboardNavSeperator(props) {
  return (
    <li role="separator" className="dropdown-divider mt-4 mb-3 border-black"></li>
  );
}

export default DashboardNavSeperator;
